
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/blujay",
      function () {
        return require("private-next-pages/integrations/blujay.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/blujay"])
      });
    }
  